import React, { Component, PropTypes } from 'react';
import { dateFormats } from '../../util/constants';
import { getDateRange } from '../../util/Etc';
import _ from 'underscore';
import moment from 'moment';
import NativeSelect from '../../components/inputs/NativeSelect';

const TODAY = moment().format(dateFormats.ISO_8601);

const getDateOptionFunction = _.memoize(
  format => _.memoize(
    date => {
      const dm = moment(date, dateFormats.ISO_8601);
      return {
        id: date,
        name: dm.format(format)
      };
    }
  )
);

export default class DateDropdown extends Component {
  static propTypes = {
    format: PropTypes.string,
    minDate: PropTypes.string,
    maxDate: PropTypes.string,
    onChange: PropTypes.func.isRequired
  };

  static defaultProps = {
    clearable: true,
    format: dateFormats.SHORT,
    minDate: TODAY,
    maxDate: TODAY,
    placeholder: 'Date'
  };

  getDates() {
    const { minDate, maxDate, format } = this.props;
    const dateFunction = getDateOptionFunction(format);

    return _.map(getDateRange({ minDate, maxDate }), dateFunction);
  }

  getValue() {
    const { value, format } = this.props;

    if (!value) {
      return null;
    }

    return (getDateOptionFunction(format))(value);
  }

  handleDateChange = value => {
    const { onChange, multiple } = this.props;

    if (multiple) {
      onChange(_.pluck(value, 'id'));
    } else {
      onChange(value ? value.id : null);
    }
  };

  render() {
    const { minDate, maxDate, format, onChange, ...rest } = this.props;

    return (
      <NativeSelect
        {...rest}
        onChange={this.handleDateChange}
        options={this.getDates()}
        value={this.getValue()}
      />
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/common/components/DateDropdown.jsx